"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import CarouselActiveItemDetails from "./carousel/CarouselActiveItemDetails";
import CarouselActiveItemVote from "./carousel/CarouselActiveItemVote";
import SubmissionCarousel, { type SubmissionCarouselHandle } from "./carousel/SubmissionCarousel";
import { CarouselHeader } from "./hero";
export default function SubmissionCarouselSection() {
  const $ = _c(18);
  const [activeDrop, setActiveDrop] = useState(null);
  const carouselRef = useRef(null);
  const isPointerInsideRef = useRef(false);
  const isVotingModalOpenRef = useRef(false);
  const isAutoplayPausedRef = useRef(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const shouldPause = isPointerInsideRef.current || isVotingModalOpenRef.current;
      if (shouldPause === isAutoplayPausedRef.current) {
        return;
      }
      isAutoplayPausedRef.current = shouldPause;
      if (shouldPause) {
        carouselRef.current?.pauseAutoplay();
      } else {
        carouselRef.current?.resumeAutoplay();
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const updateAutoplayState = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      isPointerInsideRef.current = true;
      updateAutoplayState();
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePointerEnter = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (isPointerInsideRef.current) {
        return;
      }
      isPointerInsideRef.current = true;
      updateAutoplayState();
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handlePointerMove = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      isPointerInsideRef.current = false;
      updateAutoplayState();
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handlePointerLeave = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      isVotingModalOpenRef.current = true;
      updateAutoplayState();
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleVoteOpen = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      isVotingModalOpenRef.current = false;
      updateAutoplayState();
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const handleVoteClose = t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = instance => {
      carouselRef.current = instance;
      updateAutoplayState();
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const handleCarouselRef = t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CarouselHeader />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-min-h-0 [@media(min-height:1200px)]:tw-max-h-[800px] [@media(min-width:768px)_and_(orientation:portrait)_and_(max-height:1199px)]:tw-h-[min(70svh,600px)]"><SubmissionCarousel ref={handleCarouselRef} onActiveDropChange={setActiveDrop} /></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== activeDrop) {
    t9 = activeDrop && <CarouselActiveItemVote drop={activeDrop} onVoteOpen={handleVoteOpen} onVoteClose={handleVoteClose} />;
    $[9] = activeDrop;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <section className="tw-grid tw-h-auto tw-grid-rows-[auto_1fr_auto] sm:tw-h-[100svh] [@media(min-height:1200px)]:tw-h-auto [@media(min-height:1200px)]:tw-grid-rows-[auto_auto_auto] [@media(min-width:768px)_and_(orientation:portrait)_and_(max-height:1199px)]:tw-h-auto [@media(min-width:768px)_and_(orientation:portrait)_and_(max-height:1199px)]:tw-grid-rows-[auto_auto_auto]">{t7}{t8}{t9}</section>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== activeDrop) {
    t11 = <CarouselActiveItemDetails drop={activeDrop} />;
    $[13] = activeDrop;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <div onPointerEnter={handlePointerEnter} onPointerMove={handlePointerMove} onPointerLeave={handlePointerLeave}>{t10}{t11}</div>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}